import {
  HomeOutlined,
  FileTextOutlined,
  TableOutlined,
  TagOutlined,
  PictureOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  BellOutlined,
  CalendarOutlined,
  UsergroupDeleteOutlined,
  UserOutlined,
  PlayCircleOutlined,
  MonitorOutlined,
  FireOutlined,
  SafetyCertificateOutlined,
  ZhihuOutlined,
  WhatsAppOutlined,
  SelectOutlined,
  ToolOutlined,
  AppstoreOutlined,
  BankOutlined,
  MobileOutlined,
  DashboardOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { ReactComponent as IconBuilding } from '../assets/icons/icon-building.svg';
import {
  RiApps2AiLine,
  RiBuilding4Line,
  RiBuildingLine,
  RiEarthLine,
  RiFileChartLine,
  RiMacLine,
  RiMailSettingsLine,
  RiRamLine,
  RiSettings4Line,
  RiShieldKeyholeLine,
  RiShieldUserLine,
  RiShipLine,
  RiSmartphoneLine,
  RiSpeedUpLine,
  RiUser2Line,
} from '@remixicon/react';

type IMenu = {
  type?: 'group' | 'submenu';
  key?: string;
  label: string;
  icon?: any;
  permission?: boolean | string[];
  description?: string;

  children?: IMenu[];
};

const iconSize = 20;

export const MENUS: IMenu[] = [
  {
    type: 'group',
    label: 'Monitoring',
    children: [
      {
        key: '/home',
        label: 'Home',
        icon: <RiEarthLine size={iconSize} />,
        permission: ['HOME.LIST'],
      },
      {
        key: '/dashboard',
        label: 'Dashboard',
        icon: <RiSpeedUpLine size={iconSize} />,
        permission: ['DASHBOARD.LIST'],
        description: 'See insight here',
      },
      {
        key: '/report-log',
        label: 'Report',
        icon: <RiFileChartLine size={iconSize} />,
        permission: ['DATA_LOG.LIST'],
        description: 'See insight here',
      },
    ],
  },
  {
    type: 'group',
    label: 'Assets & Company',
    children: [
      {
        permission: ['GROUP.LIST'],
        key: '/group',
        label: 'Group',
        icon: <RiBuildingLine size={iconSize} />,
      },
      {
        permission: ['COMPANY.LIST'],
        key: '/company',
        label: 'Company',
        icon: <RiBuilding4Line size={iconSize} />,
      },
      {
        permission: ['ASSET.LIST'],
        key: '/asset',
        label: 'Asset',
        icon: <RiShipLine size={iconSize} />,
      },
      {
        permission: ['DEVICE.LIST'],
        key: '/device',
        label: 'Device',
        icon: <RiSmartphoneLine size={iconSize} />,
      },
      // {
      //   permission: ['DEVICE_TYPE.LIST'],
      //   key: '/device-type',
      //   label: 'Device Type',
      //   icon: <RiRamLine size={iconSize} />,
      // },
    ],
  },
  {
    type: 'group',
    label: 'Data Configuration',
    children: [
      {
        permission: ['TEMPLATE_MESSAGE.LIST'],
        key: '/master-report',
        label: 'Master Report Email',
        icon: <RiMailSettingsLine size={iconSize} />,
      },
      {
        permission: ['OPERATION_MODE.LIST'],
        key: '/operation-mode',
        label: 'Operation Mode',
        icon: <RiSettings4Line size={iconSize} />,
      },
    ],
  },
  {
    type: 'group',
    label: 'Master Users',
    children: [
      {
        permission: ['USER.LIST'],
        key: '/admin',
        label: 'Admin',
        icon: <RiUser2Line size={iconSize} />,
      },
      {
        permission: ['CLIENT.LIST'],
        key: '/client',
        label: 'API Client',
        icon: <RiShieldKeyholeLine size={iconSize} />,
      },
      {
        permission: ['ROLE.LIST'],
        key: '/role',
        label: 'Role & Permission',
        icon: <RiShieldUserLine size={iconSize} />,
      },
    ],
  },
  // {
  //   type: 'group',
  //   label: 'App Config',
  //   children: [
  //     {
  //       permission: ['APP_CONFIG.LIST'],
  //       key: '/privacy-policy',
  //       label: 'Privacy Policy',
  //       icon: <RiShieldKeyholeLine size={iconSize} />,
  //     },
  //     {
  //       permission: ['APP_CONFIG.LIST'],
  //       key: '/terms-and-conditions',
  //       label: 'Terms and Conditions',
  //       icon: <RiSettings4Line size={iconSize} />,
  //     },
  //   ],
  // },
];

export const getFlatMenus = (menus: IMenu[]) => {
  return menus
    .reduce((acc, curr) => {
      if (curr.children) {
        curr.children.forEach((child: IMenu) => {
          acc.push(child);

          if (child.children) {
            child.children.forEach((child2: IMenu) => {
              acc.push(child2);
            });
          }
        });
      }
      acc.push(curr);
      return acc;
    }, [] as any[])
    .filter((item: any) => item.key)
    .filter((item: any) => item.type !== 'group');
};

export const MENUS_FLAT = getFlatMenus(MENUS);

export const getMenu = () => {
  return MENUS_FLAT.find(
    (item: any) => item.key === window?.location?.pathname
  );
};
